module.exports = __webpack_public_path__ + "img/fuyin.ef3544bb.png";